import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../core/routes/routes";
import { DateUtil } from "../../common/utils/date.util";
import { useStaffTimeControlQuery } from "./hooks/useStaffTimeControlQuery.js";
import IconButton from "../../common/components/IconButton";
import Table from "../../common/components/Table";
import Textfield from "../../common/components/Textfiled";
import Pagination from "../../common/components/Pagination";
import { BsClipboardPlus } from "react-icons/bs";

const columns = [
  {
    header: "Fecha",
    accessor: "date",
    render: (value) => DateUtil.format(value, "DD/MM/YYYY"),
  },
  {
    header: "Documento",
    accessor: "document",
    render: (value) =>
      value ? (
        <a href={value} target="_blank" rel="noopener noreferrer">
          Ver Documento
        </a>
      ) : (
        "No disponible"
      ),
  },
];

function ListStaffTimeControl() {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
  });
  const { staffTimeControls, loading, page, onChangePage, totalPages } =
    useStaffTimeControlQuery(filters);

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Control de horario del personal</h1>
        <div className="d-flex gap-2">
          <IconButton
            tooltipText={"Agregar control de horario del personal"}
            onClick={() =>
              navigate(ROUTES.REGISTER_FUNCTIONALITY_STAFF_TIME_CONTROL)
            }
          >
            <BsClipboardPlus size={24} />
          </IconButton>
        </div>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3 justify-content-center justify-content-md-end mb-3">
          <div className="d-flex gap-1">
            <Textfield
              label="Fecha inicio"
              type="date"
              name="startDate"
              value={filters.startDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, startDate: value }))
              }
            />
            <Textfield
              label="Fecha fin"
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, endDate: value }))
              }
            />
          </div>
        </div>

        <Table
          columns={columns}
          data={staffTimeControls}
          showIndex={true}
          loading={loading}
        />

        <Pagination
          onChangePage={onChangePage}
          page={page}
          totalPages={totalPages}
        />
      </section>
    </main>
  );
}

export default ListStaffTimeControl;
